import axios from "axios";

const API_URL = process.env.REACT_APP_HOST_API;

class EquipeService {
    
    async getAll(page = 0, size = 10, sortBy = "id", sortOrder = -1) {
        const order = sortOrder === 1 ? "asc" : "desc";
        var url = `${API_URL}/v1/equipe`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async getAllAtivas() {
        var url = `${API_URL}/v1/equipe/ativas`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async get(id) {
        var url = `${API_URL}/v1/equipe/${id}`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async save(equipe) {
        var url = `${API_URL}/v1/equipe`;
        return axios.post(url, equipe, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async delete(id) {
        var url = `${API_URL}/v1/equipe/${id}`;
        return axios.delete(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }


}

export default new EquipeService();

